.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.my-company-tab-group {
  flex: auto;
  padding: 2px;

  --tab-header-padding-left: calc(var(--spacer) * 4);
  --tab-header-padding-right: calc(var(--spacer) * 4);
  --tab-body-padding-left: calc(var(--spacer) * 4);
  --tab-body-padding-right: calc(var(--spacer));
  --tab-body-padding-top: 0;
  --tab-body-padding-bottom: 0;
}
